<template>
<span data-spec-select>
    <div class="goods-detail-item" v-if="specJson.length">
      <div class="detail-item" @click.deb="bindShowSpec()">
        <a href="javascript:;">
          <div class="item-name" data-name="已选">ေရြးျပီး</div>
            <div class="item-con">
            <dl>
              <!--goodsSpecString-->
            <dt>{{currentGoodsInfo.goodsFullSpecs|replaceLetter}}</dt>
            </dl>
            </div>
          <div class="item-more-right"></div>
          <div class="item-more"></div>
        </a>
      </div>
  </div>
  <!-- 规格选择弹出框 -->
    <transition name="ncbottom">
        <div class="nctouch-bottom-mask mask-show" v-show="show" ref="layer">
            <!--<div class="nctouch-bottom-mask-bg" @click="bindHide()" @touchmove="excludeTouch"></div>-->
            <div class="nctouch-bottom-mask-block">
                <div class="spec-options">
                    <div class="spec-close" @click="bindHide()"></div>
                    <div class="spec-img">
                        <img :src="currentGoodsInfo.imageSrc+'@240w_240h'"/>
                    </div>
                    <div class="spec-menu-top" @touchmove="excludeTouch">
                        <div class="top-price"><em>Ks{{currentGoodsPriceText}}</em><span><span>
                            <p data-name="库存">လက္က်န္{{currentGoodsInfo.goodsStorage}}</p>
                        </div>
                      <!--<div class="top-number" v-if="currentGoodsSpecString">已选：{{currentGoodsSpecString}}</div>-->
                    </div>
                    <div class="spec-select" ref="scroll">
                        <div class="prod-spec">

                            <dl class="spec" v-for="(specItem,specIndex) in specJson">
                                <dt>{{specItem.specName}}</dt>
                                <dd>
                                    <a href="javascript:;"
                                       :class="{'current':inSpecValueQueue(specIndex,specValueItem.specValueId)}"
                                       @click="bindSelectSpec(specIndex ,specValueItem.specValueId)"
                                       v-for="specValueItem in specItem.specValueList">{{specValueItem.specValueName}}</a>
                                </dd>
                            </dl>
                            <dl class="spec">
                                <dt data-name="数量">အေရအတြက္
                                <div class="spec-count">
                                    <a class="minus" href="javascript:;" @click.deb="bindMinusNum()"><em
                                      :class="{'no-change' : mNoChange}"></em></a>
                                    <input class="quantity" v-model.trim.number="buyNum" type="number" @blur="bindVerifyInputEmpty">
                                    <a class="add" href="javascript:;" @click.deb="bindAddNum()"><em
                                      :class="{'no-change' : aNoChange}"></em></a>
                                </div>
                                </dt>
                            </dl>
                        </div>
                    </div>
                  <div class="spec-bottom" v-if="groups">
                      <!-- 拼团 -->
                      <div :class="{'no-buy' :goodsDetail.goodsStatus == 0 }">
                      <!-- 单独购买 -->
                      <a v-if="isGroupNormalBuy" class="action-btn pink-btn w100" @click="bindNormalBuy()"
                      href="javascript:;"
                      @touchmove.stop="excludeTouch"><span><em>Ks{{currentGoodsPriceText}}</em></span>
                      <p>单独购买</p></a>
                      <!-- 拼团购买 -->
                      <a v-else
                      :class="[(!canBuy || (groupEnd &&!currentGoId ) ) ? 'grey-btn': 'red-btn','action-btn' , 'w100']"
                      @click="bindGroupBuy()" @touchmove.stop="excludeTouch"
                      href="javascript:;"><span><em>Ks{{currentGroupPriceText}}</em></span>
                      <p v-if="currentGoId">立即拼团</p>
                      <p v-else>{{groups.groupRequireNum}}人团</p>
                      </a>
                      </div>
                      </div>
                    <div v-else class="goods-detail-foot absolute">
                        <!-- 到货通知 -->
                            <div v-if="currentGoodsInfo.goodsStorage == 0 || !allowSend " class="action-list w100">
                                <a @click="bindArrivalNotice()" href="javascript:;"
                                   :class="['action-btn-other', 'red-btn' ,'w100' , {'grey-btn' :goodsDetail.goodsStatus== 0}]"
                                   @touchmove.stop="excludeTouch" data-name="到货通知"><p>ကုန္ပစၥည္းမရွိ</p></a>
                            </div>
                      <!-- 定金预售 -->
                      <!--<div v-else-if="isUsable==1 && currentBook &&currentGoodsInfo.promotionType == 3 "-->
                      <!--class="action-btn-other w100">-->
                      <!--<a :class="['btn-book-buy','red-btn' , {'grey-btn':!canBuy}]" @click="bindBuyBook()"-->
                      <!--@touchmove.stop="excludeTouch" href="javascript:;" data-name="支付定金">-->
                      <!--<p>支付定金</p>-->
                      <!--</a>-->
                      <!--</div>-->
                            <div v-else class="action-list w100">
                                 <a :class="['action-btn-other','w100',{'green-btn':canBuy},{'grey-btn' :!canBuy}]"
                                    @touchmove.stop="excludeTouch" @click="bindAddCart()" href="javascript:;">
                                     <p data-name="加入购物车">တြန္းလွည္းထဲထည့္ရန္</p>
                                 </a>
                              <!--<a :class="['action-btn-other','w100',{'red-btn':canBuy},{'grey-btn' :!canBuy}]"-->
                              <!--@click="bindBuyNow()" @touchmove.stop="excludeTouch" href="javascript:;">-->
                              <!--<p data-name="立刻购买">立即购买</p>-->
                              <!--</a>-->
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
  <!-- 价格显示 -->
     <span style="display: none">
            <div class="goods-detail-price" ref="showPricePanel" v-show="!this.isDiscount && !this.isBook ">
                <div class="goods-batch">
                    <!-- 普通商品价格显示 -->
                    <div class="goods-batch-price"><em>Ks{{currentGoodsPriceText}}</em></div>
                </div>
                    <!-- 黨APP價格比WAP價格高時显示APP價 -->
                <div class="goods-recommend" v-if="goodsDetail.appPrice0 < goodsDetail.wechatPrice0" @click="openAppSrc">
                    <div class="goods-recommend-price"><i class="goods-app-img"></i><em>Price on App: Ks{{goodsDetail.appPrice0|priceFormat}}</em></div>
                    <div class="item-more-right"></div>
                </div>
             </div>
     </span>
     </span>
</template>
<script>
  /**
   * 商品选择规格组件
   */
  var iScrollInstance
  export default {
    //外部传入参数
    props: [
      'goodsDetail',
      'currentSkuId',
      'showSpecSelect',
      'showPriceElement',
      'groups',
      //当前预售信息
      'currentBook',
      //标识团购是否已经结束
      'groupEnd',
      //标识是否是参团
      'currentGoId',
      //运费中标识地区是否能购买
      'allowSend',
      //团购标识单独购买
      'isGroupNormalBuy'
    ],
    /*
     * 自身数据,一定要一个function
     */
    data() {
      return {
        //当前的商品id
        currentGoodsId: 0,
        //specValue 队列
        selectSpecValueQueue: [],
        //购买数量
        oldBuyNum: 1,
        //减号不能点标识
        mNoChange: true,
        //加好不能点标识
        aNoChange: false,
        show: false,
      }
    },
//        directives:{
//          trigger:{
//            bind(el,binging){
//              el.click()
//            }
//          }
//        },
    /**
     * 计算属性
     */
    computed: {
      /**
       * 是否是预售
       */
      isBook: function () {
        return this.isUsable == 1 && this.currentBook && (this.currentGoodsInfo.promotionType == 3 || this.currentGoodsInfo.promotionType == 2);
      },
      /**
       * 是否是限时折扣
       */
      isDiscount: function () {
        var _discount = this.goodsDetail.discount;
        return this.currentGoodsInfo.promotionType == 1 && getUsable(this.currentGoodsInfo) && !Nc.isEmpty(_discount) && _discount.promotionCountDownTime > 0
      },
      //当前选择的规格名称字符串
      currentGoodsSpecString: function () {
        var _currentGoodsInfo = this.currentGoodsInfo,
          _specArray = _currentGoodsInfo.goodsFullSpecs.split(";"),
          result = []
        ;
        if (!_currentGoodsInfo.goodsFullSpecs) {
          return null
        }
        _specArray.forEach(function (value) {
          result.push("\"" + value + "\"")
        });
        return result.join(",")
      },
      //根据客户端不同，返回不同促销进行状态
      isUsable: function () {
        return getUsable(this.currentGoodsInfo)
      },
      specJson: function () {
        return this.goodsDetail.specJson;
      },
      goodsSpecValueJson: function () {
        return this.goodsDetail.goodsSpecValueJson
      },
      goodsList: function () {
        return this.goodsDetail.goodsList
      },
      /**
       * 当前商品价格
       */
      currentGoodsPriceText: function () {
        var _currentGoodsInfo = this.currentGoodsInfo;
        if (this.isUsable == 1 && this.currentBook && _currentGoodsInfo.promotionType == 3) {
          return this.$convertPrice(this.currentBook.downPayment);
        } else {
          return this.getPrice0(_currentGoodsInfo);
        }
      },
      /**
       * 当前团购价格
       */
      currentGroupPriceText: function () {
        var _currentGoodsInfo = this.currentGoodsInfo,
          _price = _currentGoodsInfo.isGroup ? _currentGoodsInfo.groupPrice : getPrice0(_currentGoodsInfo)
        ;
        return this.$convertPrice(_price)
      },
      /**
       * 当前商品信息
       */
      currentGoodsInfo: function () {
        var _goodsId = this.currentGoodsId || this.currentSkuId;
        var _a = this.goodsList.filter(function (item) {
            return item.goodsId == _goodsId
          }
        )
        return _a[0]
      },
      /**
       * 购买数量 取值于赋值
       */
      buyNum: {
        get() {
          return this.oldBuyNum;
        },
        set(newValue) {
          var _num = parseInt(newValue),
            _isUsable = getUsable(this.currentGoodsInfo),
            //库存
            _goodsStorage = this.currentGoodsInfo.goodsStorage,
            // 限购(团购的时候才有用，拼团单独购买的时候失效)
            _limit = (this.groups && !this.isGroupNormalBuy && this.groups.buyLimitNum)
              ? this.groups.buyLimitNum
              : (_isUsable && this.currentGoodsInfo.limitAmount != 0  ? this.currentGoodsInfo.limitAmount : _goodsStorage),
            //购买最大值,如果是团购商品就限购和商品库存对比
            _max = Math.min(_limit ,_goodsStorage )
          ;
          //如果小于1 就直接是1
          if (_num < 1) {
            this.oldBuyNum = 1
            return
          }
          //为最终的显示数量赋值
          this.oldBuyNum = _num > _max ? _max : _num;
          //改变加减号是否能点
          this.mNoChange = this.oldBuyNum <= 1 ? true : false;
          this.aNoChange = this.oldBuyNum == _max ? true : false
          if (this.groups && !this.isGroupNormalBuy && this.groups.buyLimitNum !=0 &&  _num > this.groups.buyLimitNum  ) {
            alertWarn("ဤပစၥည္းအ၀ယ္ကန္႔သတ္" + this.groups.buyLimitNum + this.goodsDetail.unitName)
          }
          if (_isUsable && this.currentGoodsInfo.limitAmount != 0  && _num > this.currentGoodsInfo.limitAmount) {
            alertWarn("ဤပစၥည္းအ၀ယ္ကန္႔သတ္" + this.currentGoodsInfo.limitAmount + this.goodsDetail.unitName)
          }
          //此商品限购
          this.$forceUpdate();
        }
      },
      /**
       * 是否能购买
       */
      canBuy: function () {
        var _group = this.groups,
          _currentGoodsInfo = this.currentGoodsInfo,
          _currentStorge = _currentGoodsInfo.goodsStorage,
          _allowSend = typeof this.allowSend == 'undefined' ? true : this.allowSend,
          _commonState = this.goodsDetail.goodsStatus == 1,
          _isGroup = _currentGoodsInfo.isGroup;
        return _group
          ? ( _isGroup && _currentStorge > 0 && _allowSend && _commonState)
          : (_currentStorge > 0 && _currentGoodsInfo.goodsStatus != 0 && _allowSend && _commonState )

      },
      /**
       * 购买的数据
       */
      buyData() {

        var self = this;
        return {
          buyNum: self.buyNum,
          goodsId: self.currentGoodsId
        }
      }
    },
    /**
     * 监听属性变动
     */
    watch: {
      showSpecSelect: function (value) {
        if (this.show) {
          this.bindHide()
        } else {
          // 弹出关注微信号
          if (showWeixinSubscribe("goods",{"commonId":this.goodsDetail.commonId})==true) {
            return false;
          }
          this.show = true
          //购买数量重置
          this.buyNum = 1;
        }

      },
      show:function (value) {
        if (!value) return
        this.$nextTick(function(){
          console.log('select iscroll refresh ')
          if (iScrollInstance){
            iScrollInstance.refresh()
          }else{
            iScrollInstance = new IScroll(this.$refs.scroll, {
              scrollX: false,
              scrollY: true,
              click: true
            });
          }
        })
      }
    },
    /**
     * 过滤器
     */
    filters: {
      minPrice(value) {
        return getPrice0(value)
      },
      //替换;成,号
      replaceLetter: function (value) {
        return value.replace(/；+/g, ",")
      },
      priceFormat:function (value) {
        return Nc.priceFormat(value);
      }
    },
    /**
     * 生命周期钩子
     */
    created() {

      //初始化绑定

      this.currentGoodsId = this.currentSkuId;
      this.addSelectSpecValueQueue(this.currentSkuId);
      this.openAppSrc();
    },
    mounted() {
//            this.bindSelectSpec(0,this.specValue);
//            console.log(this.specValue);
//      console.log(this.specValueItem.spaceValueId)
      var $layer = this.$refs.layer;
      var $body = document.getElementsByTagName("body")[0];
      $body.appendChild($layer);
      //移动价格显示
      var $target = document.querySelectorAll(this.showPriceElement);

      if ($target.length) {
        $target[0].appendChild(this.$refs.showPricePanel)
      }


      //如果有参团id 就直接显示spec选择框
      if (this.currentGoId) {
        // 弹出关注微信号
        if (showWeixinSubscribe("goods",{"commonId":this.goodsDetail.commonId})==true) {
          return false;
        }
        this.show = true
      }
    },
    updated() {
      this.$nextTick(function () {
        if (iScrollInstance) return

        iScrollInstance = new IScroll(this.$refs.scroll, {
          scrollX: false,
          scrollY: true,
          click: true
        });
      });
    },
    /**
     * 自定义方法
     */
    methods: {
      //打開APP
      openAppSrc:function(){
        if (getClientType() == 'fbios') {
          window.location.href = IOSSiteUrl;
        } else if (getClientType() == 'ios') {
          window.open("zegobird://commonId=" + this.commonId);
        } else {
          window.open("zego://goods:8888/goodsDetail?commonId=" + this.commonId);
        }
        window.setTimeout(function () {
          if(getClientType() == 'ios'){
            window.location.href = IOSSiteUrl;
          }else {
            alertConfirm("APP downloadလုပ္ရန္ေသခ်ာပါသလား?", function () {
              window.location = "../../zegobird.apk";
            },function () {
            }, 'YES', 'NO')
          }}, 3000);
      },
      //判断是否为空
      isEmpty: function (value) {
        return Nc.isEmpty(value)
      },
      //去除无关的touch事件
      excludeTouch: function (event) {
        event.preventDefault();
        return false;
      },
      //判断是否在规格值队列中
      inSpecValueQueue(index, specValue) {
        return this.selectSpecValueQueue[index] == specValue
      },
      //获取goodsId 根绝规格值
      setGoodsIdForSpecJson: function () {
        var self = this
        var _specJson = this.goodsSpecValueJson.filter(function (value) {

          var a = self.selectSpecValueQueue.slice(0),
            b = value.specValueIds;
          return a.sort().toString() == b.sort().toString()
        })[0];
        if (!_specJson) return;
        this.currentGoodsId = _specJson.goodsId
        this.$emit('eventModSkuId', _specJson.goodsId)
      },
      //根绝goodsid 获取规格值数组并加入队列
      addSelectSpecValueQueue(goodsId) {
        var _specValueObj = this.goodsSpecValueJson.filter(function (item) {
          return item.goodsId == goodsId
        })[0];
        if (_specValueObj) {
          this.selectSpecValueQueue = _specValueObj.specValueIds.slice(0);
        }
      },
      //点击规格值
      bindSelectSpec(index, specValue) {
        //购买数量重置
        this.selectSpecValueQueue.splice(index, 1, specValue)
        this.setGoodsIdForSpecJson()
        this.buyNum = 1;
        //获取goodsid
        this.$emit('selectspec' , this.buyData)
//                console.log(specValue)
//                console.log(specValueItem)
      },
      //隐藏
      bindHide() {
        this.show = false;
        //向父组建发送消息
        this.$emit('hide', this.buyData)
      },
      //购买数量减少
      bindMinusNum:function () {
        this.buyNum--
      } ,
      //购买数量增加
      bindAddNum : function(){
        this.buyNum++
      } ,
      //普通购买
      bindNormalBuy() {
        this.show = false
        //向父组建发送消息
        this.$emit('normalbuy', this.buyData)
      },
      //拼团购买
      bindGroupBuy() {

        if (!this.canBuy || (this.groupEnd && !this.currentGoId )) return;
        this.show = false
        //向父组建发送消息

        this.currentGoId
          ? this.$emit('joingroupbuy', this.buyData)
          : this.$emit('creategroupbuy', this.buyData)
      },
      //添加到购物车
      bindAddCart(){
        if (this.canBuy) {
          this.show = false
          this.$emit('addcart', this.buyData)
        }
      },
      //立即购买
      bindBuyNow(){

        this.canBuy && this.$emit('buynow', this.buyData)
      },
      //支付定金
      bindBuyBook: function () {

        this.canBuy && this.$emit('buybook', this.buyData)
      },
      //到货通知
      bindArrivalNotice: function () {
        var _goodsId = this.currentGoodsInfo.goodsId
        this.$emit('arrivalnotice', _goodsId)
      },
      //点击显示规格选择
      bindShowSpec: function () {
        ga('send', 'event', '选择规格按钮', '点击', '按钮点击'); //谷歌锚点
        var _commonState = this.goodsDetail.goodsStatus;
        if (_commonState != 1) {
          return
        }
        // 弹出关注微信号2
        if (showWeixinSubscribe("goods",{"commonId":this.goodsDetail.commonId})==true) {
          return false;
        }
        this.show = true
      },
      bindVerifyInputEmpty (){
        if (isNaN ( this.buyNum ) ){
          this.buyNum = 1
        }
      },
      getPrice0 : function(goods) {
        // if (getClientType() == "wechat") {
        //   return Nc.priceFormat(goods.wechatPrice0);
        // } else {
        //   return Nc.priceFormat(goods.appPrice0);
        // }
        if(!this.isDiscount && !this.isBook){
          return Nc.priceFormat(goods.webPrice0);
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/goods-spec-select/goods-spec-select.vue